import script from "./RegisterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterPage.vue?vue&type=script&setup=true&lang=js"

import "./RegisterPage.vue?vue&type=style&index=0&id=1b7bcc68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b7bcc68"]])

export default __exports__